import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("r24_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;

export const getToken = () => localStorage.getItem("r24_token");
export const setToken = (t) => localStorage.setItem("r24_token", t);
export const clearToken = () => localStorage.removeItem("r24_token");

export const CATEGORY_NAMES = {};

export const formatDate = (iso, lang = "en") => {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const diff = (now - d) / 1000;
  if (diff < 60) return lang === "hi" ? "अभी" : "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)} ${lang === "hi" ? "मिनट पहले" : "min ago"}`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} ${lang === "hi" ? "घंटे पहले" : "hrs ago"}`;
  return d.toLocaleDateString(lang === "hi" ? "hi-IN" : "en-IN", { day: "numeric", month: "short", year: "numeric" });
};

export const fullDate = (iso) => {
  if (!iso) return "";
  return new Date(iso).toLocaleString("en-IN", {
    day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
};

// Public view counter: genuine Rapid24News views only. Hidden entirely below 50 so we
// never publicly display "0 Views" or tiny counts. Formats as 128 / 1.2K / 10.4K / 1 Lakh+.
export const formatViews = (n) => {
  n = Number(n) || 0;
  if (n < 50) return null;
  if (n < 1000) return `${n}`;
  if (n < 100000) return `${(n / 1000).toFixed(1).replace(/\.0$/, "")}K`;
  return `${(n / 100000).toFixed(1).replace(/\.0$/, "")} Lakh+`;
};
